import classes from './TextInput.module.scss';

const TextInputFormik = ({ className, ...props }) => {
  const inputClassNames = [classes.input];
  if (className) {
    inputClassNames.push(className);
  }

  return <input className={inputClassNames.join(' ')} {...props} />;
};

export default TextInputFormik;
